import React, { Component, Fragment } from 'react'
import { Button, Icon } from 'antd'

export default class ConfirmButton extends Component<any> {
    state = {
        confirm: false
    }

    confirmToggle = confirm => {
        this.setState({ confirm })
    }

    confirm = () => {
        this.props.confirmed()
        this.confirmToggle(false)
    }

    render() {
        const { confirm } = this.state
        const { buttonText, confirmQuestion, confirmText, cancelText, icon, style } = this.props

        const buttonContent = confirm ? (
            <Fragment>
                {confirmQuestion ? <span style={{ marginLeft: '0.5rem' }}>{confirmQuestion}</span> : ''}
                <Button onClick={() => this.confirmToggle(false)}>{cancelText || 'לא'}</Button>
                <Button type="danger" onClick={() => this.confirm()}>
                    {confirmText || 'כן'}
                </Button>
            </Fragment>
        ) : (
            <Button style={style ? { ...style } : {}} onClick={() => this.confirmToggle(true)}>
                {icon ? <Icon type={icon} /> : ''}
                {buttonText}
            </Button>
        )

        return <Fragment>{buttonContent}</Fragment>
    }
}
